import { render, staticRenderFns } from "./FadeInBox.vue?vue&type=template&id=29c81d72&scoped=true"
import script from "./FadeInBox.vue?vue&type=script&lang=js"
export * from "./FadeInBox.vue?vue&type=script&lang=js"
import style0 from "./FadeInBox.vue?vue&type=style&index=0&id=29c81d72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c81d72",
  null
  
)

export default component.exports